import React from 'react';
import {store} from '../football_stats.jsx';

function getTeamInstatId(teamId) {
    if(typeof store != 'undefined') {
        return store.getState().teams[teamId].instatId;
    }

    return;
}

const StatsWidgetStatsRow = ({
    stats,
    player,
    team,
    category,
    round = 0,
    stage='RegularSeason',
    season = '26/27',
    league = '902',
    type= 'player'
}) => {

    //TODO: change image ID for new season
    var seasonImagePrefix = {
        "16/17": 18,
        "17/18": 20,
        "18/19": 22,
        "19/20": 24,
        "20/21": 26,
        "21/22": 28,
        "22/23": 30,
        "23/24": 32,
        "24/25": 421,
        "25/26": 430,
        "26/27": 436
    };

    var defaultImgUrl = 'https://static.football.co.il/wp-content/themes/kingclub-theme/images/players/43854.png';
    var link = "#";

    //Default Team Id
    var teamInstatId = typeof player != 'undefined' && player != null && typeof player.teamInstatId != 'undefined' && player.teamInstatId != null ? player.teamInstatId : '';
    var teamId = typeof player != 'undefined' && player != null && typeof player.teamId != 'undefined' && player.teamId != null ? player.teamId : '';

    if(typeof teamId == 'object') {
        teamId = teamId.id;
    }

    //TODO: get team by selected year using the clubs array and use that for teamInstatId, please try that.
    if(type == "player") {
        console.log('player ' + player.id + ' teamId ' + player.teamId + ' team instatId ' + player.teamInstatId + ' missing clubs ' + 'current season ' + currentSeason  + " season " + season );

        if(season != currentSeason && typeof player.clubs != 'undefined') {
            for (var i = 0; i < player.clubs.length; i++) {
                var pastLeague = player.clubs[i].tournamentId != "undefined" ? player.clubs[i].tournamentId : -1;
                var pastSeason = player.clubs[i].seasonName != 'undefined' ? player.clubs[i].seasonName : -1;
                var pastTeamId = player.clubs[i].teamId;

                if(pastSeason == season && league == pastLeague) {
                    teamInstatId = getTeamInstatId(pastTeamId);
                }
            }
        } else {
            if(player.teamInstatId != -1) {
                teamInstatId = player.teamInstatId;
            } else if (player.teamId != -1) {
                if(teamInstatId == "" || teamInstatId == -1) {
                    teamInstatId = getTeamInstatId(player.teamId);
                }
            }
        }
    }

    var instatId = typeof player != 'undefined' && player != null && typeof player.instatId != 'undefined' && player.instatId != null ? player.instatId : '';
    var id = typeof player != 'undefined' && player != null && typeof player.id != 'undefined' && player.id != null ? player.id : '';

    var imageUrl =  defaultImgUrl;
    var baseImageDirectory = 'https://static.football.co.il/wp-content/themes/kingclub-theme/images/';

    //TODO: support previous seasons images for players.
    if(type == 'player') {
        if(seasonImagePrefix[season] >= 32) {
            imageUrl = baseImageDirectory + 'players/' + seasonImagePrefix[season] + '-' + teamId + '-' + id + '.png';
        } else if(isset(teamInstatId) && isset(instatId)) {
            imageUrl = baseImageDirectory + 'players/' + seasonImagePrefix[season] + '-' + teamInstatId + '-' + instatId + '.png';
        }

    } else {
        if(isset(team) && isset(team.id)) {
            imageUrl = baseImageDirectory + 'teams/' + team.id + '.png';
        }
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var noHeader = urlParams.get("noHeader");

    if(noHeader != "true") {
        link = type == 'player' ? getPlayerLink(player.id) : getTeamLink(team.id);
    }

    let classNames = 'image lazy';
    return (
        <li className={"player-list-item"}>
            <a href={link}>
                <img className={classNames} src={imageUrl} data-src={imageUrl} ref={img => imageUrl = img} onError={
                    () => imageUrl.src = defaultImgUrl
                }/>
            </a>
            <div className="player-list-player-info">
                <a href={link}>
                    <label className="player-list-player-name ">{ type == 'player' ? getObjField(player) : typeof team != 'undefined' ? getObjField(team) : ''}</label>
                </a>
                {type == 'player' ? <label
                    className="player-list-player-role">{typeof player.shirtNumber != 'undefined' && player.shirtNumber ? player.shirtNumber + " | " + getObjField(player, 'position') : null}</label> : ""}
            </div>
            <label className={type == 'player' ? "player-list-player-count" : "player-list-team-count"}>
                { category.field == 'leftSideAttack' || category.field == 'rightSideAttack' || category.field == 'centerAttack' ?
                     (stats[category.field] * 100).toFixed(2) + "%" : stats[category.field].toFixed(2).replace(/[.,]00$/, "")
                }
            </label>
        </li>
    )

};

export default StatsWidgetStatsRow;


